import $ from 'jquery';

$(function () {
  //   Check if the user already accepted it
  if (window.localStorage.getItem('remove_banner')) {
    $('.banner').hide();
    $('body').removeClass('banner--visible');
  } else {
    $('.banner').css('display', 'flex');
  }

  $('.banner__close-icon').on('click', () => {
    // Save on LocalStorage
    window.localStorage.setItem('remove_banner', true);
    $('.banner').hide();
    $('body').removeClass('banner--visible');
  });
});
